/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";

import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  inicioIntervaloCadastroLead?: string;
  fimIntervaloCadastroLead?: string;
  inicioIntervaloAtualizacaoLead?: string;
  fimIntervaloAtualizacaoLead?: string;
  idsMotivosDesqualificacaoLeadSistemaOrigem?: string[];
  leadCliente?: boolean;
  leadVisitouEmpreendimento?: boolean;
  leadPassouPelaOfertaAtiva?: boolean;
  quantidadeVezesLeadPassouPelaOfertaAtiva?: number;
  idsOrigensLeadSistemaOrigem?: string[];
  idsCanaisLeadSistemaOrigem?: string[];
  idsTemperaturasLeadSistemaOrigem?: string[];
  idsRendasFamiliaresLeadSistemaOrigem?: string[];
  etapas?: string[];
  idsSubetapasSistemaOrigem?: string[];
  etapasAnterioresLead?: string[];
  idsSubEtapasAnterioresLeadSistemaOrigem?: string[];
  idsProdutosInteresseSistemaOrigem?: string[];
  apenasLeadsSemProdutos?: boolean;
  idsTiposEmpreendimentosSistemaOrigem?: string[];
  quantidadesDormitorios?: number[];
  idsZonasEmpreendimentosSistemaOrigem?: string[];
  idsBairrosEmpreendimentosSistemaOrigem?: string[];
  inicioIntervaloValorImovel?: string;
  fimIntervaloValorImovel?: string;
  idsObjetivosCompraSistemaOrigem?: string[];
  idsPrazosEntregaSistemaOrigem?: string[];
}

export function useQuantidadeContatos() {
  const postData = async (props: Props) => {
    const QUANTIDADE_CONTATOS = `${leadsWebEnviroment}/common/campanha/quantidade-contatos/v1`;
    const response = await instance.post(QUANTIDADE_CONTATOS, {
      inicioIntervaloCadastroLead: props.inicioIntervaloCadastroLead,
      fimIntervaloCadastroLead: props.fimIntervaloCadastroLead,
      inicioIntervaloAtualizacaoLead: props.inicioIntervaloAtualizacaoLead,
      fimIntervaloAtualizacaoLead: props.fimIntervaloAtualizacaoLead,
      idsMotivosDesqualificacaoLeadSistemaOrigem:
        props.idsMotivosDesqualificacaoLeadSistemaOrigem,
      leadCliente: props.leadCliente,
      leadVisitouEmpreendimento: props.leadVisitouEmpreendimento,
      leadPassouPelaOfertaAtiva: props.leadPassouPelaOfertaAtiva,
      quantidadeVezesLeadPassouPelaOfertaAtiva:
        props.quantidadeVezesLeadPassouPelaOfertaAtiva,
      idsOrigensLeadSistemaOrigem: props.idsOrigensLeadSistemaOrigem,
      idsCanaisLeadSistemaOrigem: props.idsCanaisLeadSistemaOrigem,
      idsTemperaturasLeadSistemaOrigem: props.idsTemperaturasLeadSistemaOrigem,
      idsRendasFamiliaresLeadSistemaOrigem:
        props.idsRendasFamiliaresLeadSistemaOrigem,
      etapas: props.etapas,
      idsSubetapasSistemaOrigem: props.idsSubetapasSistemaOrigem,
      etapasAnterioresLead: props.etapasAnterioresLead,
      idsSubEtapasAnterioresLeadSistemaOrigem:
        props.idsSubEtapasAnterioresLeadSistemaOrigem,
      idsProdutosInteresseSistemaOrigem:
        props.idsProdutosInteresseSistemaOrigem,
      apenasLeadsSemProdutos: props.apenasLeadsSemProdutos,
      idsTiposEmpreendimentosSistemaOrigem:
        props.idsTiposEmpreendimentosSistemaOrigem,
      quantidadesDormitorios: props.quantidadesDormitorios,
      idsZonasEmpreendimentosSistemaOrigem:
        props.idsZonasEmpreendimentosSistemaOrigem,
      idsBairrosEmpreendimentosSistemaOrigem:
        props.idsBairrosEmpreendimentosSistemaOrigem,
      inicioIntervaloValorImovel: props.inicioIntervaloValorImovel,
      fimIntervaloValorImovel: props.fimIntervaloValorImovel,
      idsObjetivosCompraSistemaOrigem: props.idsObjetivosCompraSistemaOrigem,
      idsPrazosEntregaSistemaOrigem: props.idsPrazosEntregaSistemaOrigem,
    });
    return response?.data?.data;
  };
  const mutation = useMutation({
    mutationFn: postData,
    onSuccess: () => {},
    onError: () => {},
  });

  return mutation;
}
